<template>
    <div>
        <compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
            <compFormQuery v-if="type == 'query'" class="margin-top-15 margin-right-15 width-50per" :formdata="getBase"
                :value="formData" :labelWidth="150" :col="1" placeholder="--">
            </compFormQuery>

            <compFormEdit v-else class="margin-top-15 margin-right-15 width-50per" ref="editform" :formdata="getBase"
                v-model="formData" :labelWidth="150" :col="1">
            </compFormEdit>
            <template v-if="type != 'query'" slot="footer">
                <vButton class="margin-right-20" theme="primary" @click="submit">{{ $t('global.common.save', {
                    defaultValue:
                        "保存"
                }) }}</vButton>
                <vButton class="margin-right-20" @click="cancel">{{ $t('global.common.operation_cancel', {
                    defaultValue: "取消"
                }) }}</vButton>
            </template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history', { defaultValue: '操作历史' })" theme="gray"
            v-if="type === 'query'">
            <compLog class="margin-layout" :data="logList" :columns="logcolumn"></compLog>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetDisacountRateOne, HttpUpdateDisacountRateeOne, HttpSaveDisacountRateeOne } from '@/service/account';
import { HttpProductList } from '@mods/service/dictionary';
import { HttpOtherLogiServiceList, HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import { HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";

import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    props: ['activeid', 'querytype'],
    mixins: [mixin],
    data() {
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            logList: [],
            productList: [],
            groupList: [],
            groupServiceList: [],
            formData: {
                regionCode: '',
            },
            loading: false,
            showline: false,
            showcarrier: false,
            showrange: false,
            showZone: false,
        }
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
    },
    created() {
        this.getDetail();
        // this.getGroupServiceList(0);
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList', 'getCarrierServiceList', 'getCountryList']),
        getBase() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: '组织' }),
                    key: "organizationId",
                    tag: 'Select',
                    options: this.getNextOrgList,
                    query: this.type != 'add',
                    props: {
                        filterable: true,
                    },
                    on: {
                        'on-change': (val) => {
                            if (val) {
                                this.getProduct(val);
                                this.getOrgGroupList(val);
                            } else {
                                this.productList = [];
                                this.groupList = [];
                            }

                        }
                    }
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_discount_type', { defaultValue: '折扣类型' }),
                    key: "discountType",
                    tag: 'Select',
                    options: this.getDisacountType,
                    on: {
                        'on-change': (val) => {
                            this.resetRegionCode();
                            this.showItem(val)
                        }
                    },
                    query: this.type != 'add',
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    tag: 'Select',
                    key: 'regionCode',
                    options: this.getCountryList.map(item => {
                        return {
                            value: item.value,
                            label: item.label
                        }
                    }),
                    show: this.formData.discountType === 10,
                    query: this.type != 'add',
                },
                {
                    label: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: "lineId",
                    tag: 'Select',
                    options: this.productList.map(item => {
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }),
                    props: {
                        filterable: true
                    },
                    query: this.type != 'add',
                    show: this.showline
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    key: "groupId",
                    tag: 'Select',
                    options: this.groupList,
                    props: {
                        filterable: true
                    },
                    on: {
                        'on-change': (val) => {
                            this.formData.carrierServiceId = ''
                            if (val) {
                                this.getGroupServiceList(val);
                            } else {
                                this.groupServiceList = []
                            }
                        }
                    },
                    // query:this.type!='add',
                    show: this.showcarrier && this.type == 'add',
                },
                {
                    label: "物流产品",
                    key: "groupName",
                    show: this.showcarrier && this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceId",
                    tag: 'Select',
                    options: this.groupServiceList,
                    props: {
                        filterable: true
                    },
                    // on:{
                    //     'on-change':(val)=>{
                    //         this.getRegionCountry(val)
                    //     }
                    // },
                    // query:this.type!='add',
                    show: this.showcarrier && this.type == 'add',
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceCode",
                    show: this.showcarrier && this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    query: true,
                    tag: "div",
                    children: (h) => {
                        const region = this.getCountryList.filter(item => item.value === this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    show: this.showcarrier && this.type !== 'query',
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: 'regionCode',
                    render: (h) => {
                        const regionCountry = this.getCountryList.filter(item => item.value === this.formData.regionCode)[0]
                        return regionCountry ? regionCountry.label : '--'
                    },
                    show: this.showcarrier && this.type === 'query'
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_weight_min', { defaultValue: '重量区间最小值(lbs)' }),
                    key: "weightRangeMin",
                    show: this.showrange
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_weight_max', { defaultValue: '重量区间最大值(lbs)' }),
                    key: "weightRangeMax",
                    show: this.showrange
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_zoneStart', { defaultValue: 'Zone区间最小值' }),
                    key: "zoneStart",
                    show: this.showZone
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_zoneEnd', { defaultValue: 'Zone区间最大值' }),
                    key: "zoneEnd",
                    show: this.showZone
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_rate', { defaultValue: '折扣率' }),
                    key: "discount",
                },
                {
                    label: '生效开始日期',
                    key: 'startTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: '生效结束日期',
                    key: 'endTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ]
        },

    },
    methods: {
        resetRegionCode() {
            this.formData.regionCode = '';
        },
        getRegionCountry(val) {
            const groupService = this.groupList.filter(item => {
                return item.value == val
            })
            this.formData.regionCode = groupService[0] ? groupService[0].attach.regionCode : ''
        },
        getOrgGroupList(val) {
            HttpGetServiceList({
                // HttpGetCarrierGroupByOrg({
                // contextId:global.SYSID,
                customerId: val,
            }).then(
                (res) => {
                    this.groupList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.carrierGroupCode,
                            attach: item,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getGroupServiceList(val) {
            HttpGetServiceProductList({
                // HttpOtherLogiServiceList({
                contextId: global.SYSID,
                carrierGroupId: val,
                orgId: this.formData.organizationId,
            }).then(
                (res) => {
                    this.groupServiceList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.code,
                            attach: {
                                ...item
                            },
                        };
                    });
                    this.getRegionCountry(val)
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        showItem(val) {
            switch (val) {
                case 10: this.showline = this.showcarrier = this.showrange = false; this.showZone = false; break;
                case 20: this.showline = this.showrange = false; this.showcarrier = true; this.showZone = false; break;
                case 30: this.showline = false; this.showZone = false; this.showcarrier = this.showrange = true; break;
                case 21: this.showline = true; this.showZone = false; this.showcarrier = true; this.showrange = false; break;
                case 31: this.showline = true; this.showZone = false; this.showcarrier = true; this.showrange = true; break;
                case 50: this.showline = false; this.showcarrier = this.showrange = this.showZone = true; break;
                //case 40: this.showline = true; this.showcarrier = this.showrange = false; break;
            }
        },
        getDetail() {
            if (this.type == 'add') return
            this.loading = true
            HttpGetDisacountRateOne({
                id: this.id
            }).then(res => {
                this.formData = res.data.customerCarrierDiscountsEntity
                this.showItem(res.data.customerCarrierDiscountsEntity.discountType)
                this.logList = res.data.updateLogEntities
                this.getProduct(this.formData.organizationId);
                this.getOrgGroupList(this.formData.organizationId);
                this.getGroupServiceList(this.formData.groupId)
                this.loading = false
            }, err => {
                this.$VMessage.error(err.message)
                this.loading = false
            })
        },
        getProduct(val) {
            HttpProductList({
                contextId: val
            }).then(res => {
                // console.log(res.data)
                this.productList = res.data

            })

        },
        async submit() {
            const valid = await this.$refs.editform.validate()
            if (!valid) return;
            
            this.loading = true;
            if (this.type == 'add') {
                HttpSaveDisacountRateeOne({
                    ...this.formData
                }).then(res => {
                    this.$VMessage.success(res.message)
                    this.loading = false;
                    this.cancel();
                }, err => {
                    this.$VMessage.error(err.message)
                    this.loading = false;
                })
            } else {
                HttpUpdateDisacountRateeOne({
                    ...this.formData
                }).then(res => {
                    this.$VMessage.success(res.message)
                    this.loading = false;
                    this.cancel();
                }, err => {
                    this.$VMessage.error(err.message)
                    this.loading = false;
                })
            }
        },
        cancel() {
            this.$router.push({ name: 'cusdisacountrateList' });
        }
    }
}
</script>
